import { debounce } from "lodash/function";

const defaultOptions = {
  slidesPerView: 2,
  speed: 200,
  spaceBetween: 20,
  breakpoints: {
    992: { slidesPerView: 5, spaceBetween: 60 },
    600: { slidesPerView: 3, spaceBetween: 40 },
  },
};

const pixelsPerSecond = typeof window.globalMarqueeSpeed === "number" ? window.globalMarqueeSpeed : 100;

const marquees = document.querySelectorAll(".marquee-content");
marquees.forEach((wrapper) => {
  const content = wrapper;
  if (!content) return;
  const contentWidth = content.scrollWidth;
  let duration = contentWidth / pixelsPerSecond;
  content.style.animationDuration = `${duration}s`;
});

export function autoplaySwiper(block, options = {}) {
  const { slidesPerView, spaceBetween, breakpoints, speed } = {
    ...defaultOptions,
    ...options,
  };
  
  const root = block.querySelector(".autoplay-swiper-cont");
  const container = block.querySelector(".autoplay-swiper");
  const wrapper = block.querySelector(".autoplay-swiper-wrapper");
  const modal = document.querySelector(".custom-modal");
  const customModalContent = document.querySelector(".custom-modal-content");
  if (!container || !root || !wrapper) return;
  
  const isRTL = (() => {
    const htmlDir = (document.documentElement.getAttribute("dir") || "").toLowerCase();
    if (htmlDir === "rtl") return true;
    try {
      const dir = getComputedStyle(root).direction;
      return dir === "rtl";
    } catch {
      return false;
    }
  })();
  
  // === animation duration & direction ===
  container.style.animationDuration = `${speed / 3000}s`;
  container.style.animationDirection = isRTL ? "reverse" : "normal";
  container.style.display = "flex";
  container.style.flexDirection = isRTL ? "row-reverse" : "row";
  
  container.appendChild(wrapper.cloneNode(true));
  
  const points = Object.keys(breakpoints).sort((a, b) => Number(b) - Number(a));
  
  let activeSpaceBetween = spaceBetween;
  let activeSlidesPerView = slidesPerView;
  let activeContainerWidth = root.clientWidth;
  const partClones = [];
  
  const updatePartCount = () => {
    const wrapperWidth = wrapper.clientWidth;
    container.style.width = `${wrapperWidth}px`;
    
    const rootWidth = root.clientWidth;
    const cloneCount = Math.floor(rootWidth / wrapperWidth);
    
    if (cloneCount > partClones.length) {
      const addCount = cloneCount - partClones.length;
      [...Array(addCount)].forEach(() => {
        const newNode = wrapper.cloneNode(true);
        partClones.push(newNode);
        container.appendChild(newNode);
        
        // Reattach modal handlers to cloned slides
        newNode.querySelectorAll(".play-btn").forEach((btn) => {
          btn.addEventListener("click", function () {
            document.documentElement.classList.add("modal-opened");
            modal.classList.add("modal-active");
            const modalTemplate = btn.closest(".autoplay-swiper-slide").querySelector(".video-template");
            const clone = modalTemplate.content.cloneNode(true);
            customModalContent.appendChild(clone);
          });
        });
      });
    }
    
    while (partClones.length > cloneCount) {
      const node = partClones.pop();
      if (node && node.parentNode) node.parentNode.removeChild(node);
    }
  };
  
  const handleSlidesWidth = debounce(() => {
    if (points.length) {
      const currentBreakpoint = points.find((p) => window.innerWidth >= Number(p));
      if (currentBreakpoint) {
        const reversed = [...points].reverse();
        const bpConf = breakpoints[currentBreakpoint] || {};
        const fallbackSlides = reversed
            .map((p) => breakpoints[p]?.slidesPerView)
            .find((v) => typeof v === "number");
        const fallbackSpace = reversed
            .map((p) => breakpoints[p]?.spaceBetween)
            .find((v) => typeof v === "number");
        
        activeSlidesPerView = bpConf.slidesPerView ?? fallbackSlides ?? slidesPerView;
        activeSpaceBetween = bpConf.spaceBetween ?? fallbackSpace ?? spaceBetween;
      } else {
        activeSlidesPerView = slidesPerView;
        activeSpaceBetween = spaceBetween;
      }
    }
    
    activeContainerWidth = root.clientWidth;
    
    const slideWidth =
        (activeContainerWidth - (activeSlidesPerView - 1) * activeSpaceBetween) / activeSlidesPerView;
    
    const slides = block.querySelectorAll(".autoplay-swiper-slide");
    slides.forEach((slide) => {
      slide.style.width = `${slideWidth}px`;
      
      if (isRTL) {
        slide.style.marginLeft = `${activeSpaceBetween}px`;
        slide.style.marginRight = "0";
      } else {
        slide.style.marginRight = `${activeSpaceBetween}px`;
        slide.style.marginLeft = "0";
      }
      slide.style.marginInlineEnd = isRTL ? "0" : `${activeSpaceBetween}px`;
      slide.style.marginInlineStart = isRTL ? `${activeSpaceBetween}px` : "0";
    });
    
    updatePartCount();
  }, 200);
  
  handleSlidesWidth();
  
  const resizeHandler = () =>
      activeContainerWidth !== container.clientWidth && handleSlidesWidth();
  window.addEventListener("resize", resizeHandler);
}
